import React, { useState } from 'react';

import './styles.css';

export default ({ label, onChange, value, multiline, required }) => {
    const [state, setState] = useState({
        filled: value && value.length,
    });

    const type = e => {
        setState({ filled: e.target.value !== '' });
        onChange(e);
    };
    let classes = 'text-field';
    if (state.filled) {
        classes += ' filled';
    }

    return (
        <div className={classes}>
            {multiline ? (
                <textarea
                    id={label}
                    onChange={type}
                    value={value}
                    required={required}
                />
            ) : (
                <input
                    id={label}
                    onChange={type}
                    value={value}
                    required={required}
                />
            )}
            <label htmlFor={label}>{label}</label>
        </div>
    );
};
